import { MapData } from './laundrette.data';
import { EventsRawData, NewsAndEvent, WelcomeWeekEvent } from "../types/welcomeWeekTypes";
import { parse } from "date-fns"

const prodKey = 'da2-kzeei4tw7jekpmss5tc2aob7xu';
const stagingKey = 'da2-v5r43l7yunebdkpwgfcgc3nf44';

const eventsUrl =
  process.env.REACT_APP_ENV === "production"
    ? 'https://sx3blo4q2bhtzmypt3g77qdhl4.appsync-api.eu-west-2.amazonaws.com/graphql'
    : 'https://i77bsirmyvcszaqtnywotvrjr4.appsync-api.eu-west-2.amazonaws.com/graphql'

export const GET_EVENTS = `
  query GetWelcomeWeekEvents($courseId: String!) {
    getWelcomeWeekEvents(courseId: $courseId) {
      newsAndEvents {
      __typename
        EventId
        Location {
          LocationId
          LocationName
          Latitude
          Longitude
          Online
        }
        Title
        StartDate
        EndDate
        Website
        ShortDescription
        ImageLink
        ImageAltText
        EventDetails {
          Biography
          Cost
          Abstract
        }
        Tags {
          Name
        }
      }
      welcomeWeekEvents {
      __typename
        id
        title
        cost
        description
        long_description
        utcStart
        finishes_at
        website
        categories {
          type
          value
        }
        location {
          id
          latitude
          longitude
          name
          pictureURL
        }
      }
    }
  }
`;

export const getAllEvents = (async () => {
  const localEventsString = localStorage.getItem("filteredEvents");
  const storedEventsFull = localEventsString ? JSON.parse(localEventsString) : null;
  const storedEvents = storedEventsFull.slice(0,150)  //slicing stored events to the first 20 as mapDataTransform does an API call for nearly every item (very slow)
  const mapData = await mapDataTransform(storedEvents? storedEvents : [])
  return {allData: storedEvents, mapData: mapData};
});

export const getPinEvents = async (longitude: number, latitude: number) => {
  const eventsData = await getAllEvents();
  const mapEvents = eventsData.mapData;
  const eventsWithSameLocation = mapEvents.filter((event) => {
    const eventLongitude = Number(event.location?.[0].longitude);
    const eventLatitude = Number(event.location?.[0].latitude);  
    return eventLongitude === longitude || eventLatitude === latitude;
  });
  return eventsWithSameLocation;
};


export const getSelectedEvent = async (eventID: string, located: boolean) => {
  const eventsData = await getAllEvents();
  if (located) {
  const locatedEvents = eventsData.mapData;
  const selectedEvent = locatedEvents.find(
    (event: WelcomeWeekEvent) => event.id === eventID)
  return selectedEvent;}
  else {
    const unlocatedEvents = eventsData.allData;
    const selectedEvent = unlocatedEvents.find(
      (event: WelcomeWeekEvent) => event.id === eventID)
    return selectedEvent;
  }
}

const mapDataTransform = async (data: WelcomeWeekEvent[]) => {
  let newData: WelcomeWeekEvent[] = []
  
  for (const event of data){ // Loop through each event
    
    if(event.location && event.location.length > 0){ // Get all of the events that actually have a location array
      const longitude = Number(event.location?.[0].longitude); // Convert to number
      const latitude = Number(event.location?.[0].latitude);   // Convert to number
      
      if ((longitude !== 0 && latitude !== 0) && (!isNaN(longitude) && !isNaN(latitude))) {
        newData.push(event); // Push the events that have a proper lat and long straight to the events to be shown on map
      } else { // This means the event has a location array but doesn't have a proper long and lat
        if ((event.location?.[0]?.id as string)?.length > 10) {
          // Ignore events with no long&lat but with a long ID string (no plannon ID, location cannot be retrieved)
        } else {
          const latLong = await resolvePlannonId(event.location?.[0].id as string);
          if (latLong !== "error"){
            newData.push({
              ...event,  // For the events that have no long&lat but have a plannon ID, we call a function to retrieve their location
              location: [
                {
                  id: event.location[0].id,
                  latitude: Number(latLong?.latitude),
                  longitude: Number(latLong?.longitude),
                  name: event.location[0].name,
                  pictureURL: event.location[0].pictureURL
                }
              ]
            });
            
          }
        }
      }
    }
  }
  
  return newData;
};


const resolvePlannonId = async (id: string) => {
  const response = await fetch(
    `https://api.mazemap.com/api/pois/?identifier=${id}&srid=4326&lang=&campuscollectiontag=lancaster`,
  );
  const responseJSON = await response.json();

  if (response.ok && responseJSON.pois.length !== 0) {
    var firstPoi = responseJSON.pois[0];
    if (firstPoi.point.coordinates[1] == null || firstPoi.point.coordinates[0] == null){
      return "error"
    } else {
      return {latitude: firstPoi.point.coordinates[1], longitude: firstPoi.point.coordinates[0]}
    }
    
  }
  else {
    return "error"
  }
}
